var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-ArrowRight Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.943 11.853a.88.88 0 0 1-.211.517l-6.002 6.395a.75.75 0 0 1-1.06.03c-.292-.264-.3-.778-.03-1.064l4.818-5.126H4.752a.752.752 0 1 1 0-1.504h13.706L13.64 5.975c-.27-.286-.25-.787.03-1.063a.75.75 0 0 1 1.06.03l6.002 6.394a.67.67 0 0 1 .211.517"
}))));
export default SvgArrowRight;